import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const checkmarkFilled = svgToTinyDataUri(
  `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5530_14978)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8ZM12.4714 5.80474C12.7318 5.54439 12.7318 5.12228 12.4714 4.86193C12.2111 4.60158 11.7889 4.60158 11.5286 4.86193L6.66667 9.72386L4.4714 7.5286C4.21106 7.26825 3.78894 7.26825 3.5286 7.5286C3.26825 7.78895 3.26825 8.21106 3.5286 8.47141L6.19526 11.1381C6.45561 11.3984 6.87772 11.3984 7.13807 11.1381L12.4714 5.80474Z" fill="#AFE321"/>
</g>
<defs>
<clipPath id="clip0_5530_14978">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>`
);
